import { Injectable } from '@angular/core';
import { ReligionBranch } from '../components/religion-branch/religion-branch.component';
import { Localized } from '../../../objects';
import { ApiService } from '../../../services/api.service';

@Injectable()
export class LanguageStyleService {

  private cache: LanguageStyle[];

  constructor(private apiSvc: ApiService) { }

  public loadEntities(): Promise<LanguageStyle[]> {

    const p = new Promise<LanguageStyle[]>((resolve, reject) => {

      if (this.cache && this.cache.length > 0) {
        console.log("LanguageStyle cache detected");
        resolve(this.cache);
        return;
      }

    this.apiSvc.get("api/languagestyle", null).subscribe(
      (data: LanguageStyle[]) => {
        console.log(data);
        this.cache = data;
        resolve(this.cache);
      },
      (err) => {
        console.log("error", err);
      }
    );

  });

  return p;

}

}

export class LanguageStyle {
  Id: number;
  DisplayOrder: number;
  Localized: Localized[];
  ReligionBranch: ReligionBranch;
}
